import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WechatIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wechat"}/>
}
